import React, { useState, useEffect } from 'react';
import {Button} from '@progress/kendo-react-buttons';
// import '../styles/card-style.css';
import { CardImage } from '@progress/kendo-react-layout';
import Popup from '../components/CusPopup';
import CusFaCb from '../components/CusFaCb';
import CusParagraph from '../components/CusParagraph';
import '../components/Popup.css';
import {FcCollapse, FcExpand} from "react-icons/fc";
import { Checkbox } from '@progress/kendo-react-inputs';
import { useHistory } from "react-router-dom";
import stateApiService from '../services/StateApiService';
import service from '../services/ApiService.js';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import storage from '../factory/StorageFactory';
import helper from '../factory/Helper';
import CusToast from '../components/CusToast';
import welcomedata from '../data/welcomedata.json';
import bannerImg from '../images/sme-banner1.png'
import myInfoBtn from '../images/WelcomeMyInfoBtn.png';
import singPassImg from '../images/singpass_logo_fullcolours-1.png';
import SubHeader from '../components/SubHeader';

const fbaData = welcomedata;
let faCb1Data = welcomedata.greenCb1.data;
let faCb2Data = welcomedata.greenCb2.data;
let faCb3Data = welcomedata.greenCb3.data;

const dcData = welcomedata.dcPopup.data;

let codeValue = ''; // to validate in Myinfolanding for simulator 
const Welcome = props => {

    let timer;
    const history = useHistory();

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [buttonPopup, setButtonPopup] = useState(false);
    const [show,setShow]= useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [titleName, setTitleName] = useState('');
    const [userName,setUserName] = useState('');

    const [stateId,setStateId] = useState('');
    const [isFirstTimeUser, setFirstTimeUser] = useState(false);
    const [isContinue, setIsContinue] = useState(false);
    const [isConsentFirstUser,setIsConsentFirstUser] = useState(false);
    const [idNum,setIDNum] = useState('');
    const [type,setType] = useState();
    const [uen,setUEN] = useState('');

    useEffect(() => {

        getOptionfromQueryString();
        
        
        return function cleanup() {
            setIsLoading(false);
            clearTimeout(timer);
        };
     }, []);

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const handleProceed = () => {
        setButtonPopup(false);
        checkRouteHistory();
    }

    const callPostState = (params,) => {  //create state ID
     
        setIsLoading(true);
      
        stateApiService.postResumeState(params).then(res => {
            let resData = res.data;
            if(resData.isSucess) {
               checkStatus(resData.model);
            }
        }).catch(err =>{
            setIsLoading(false);
            showErrMsg('Service is not available.')
        }) 
    }
    

    const checkRouteHistory = () => {
        if(helper.isTokenExpired()) { // check token expired
            history.push(config.route.SessionExpired);
            return;
        }

        let browserParams = getBrowserInfo();
   
        
        let params ={};
        if(isConsentFirstUser === true && isContinue === true) { //firstUser save&continue  && isContinue === true
            // console.log('first user resume!')
            codeValue = uen;
            storage.setIsFirstTime(true); //first time user save&continue is true
            let dfields ='<Fields><stateId>'+stateId+'</stateId><type>'+type+'</type><referenceNo>'+storage.getRefNo()+'</referenceNo><IsContinue>'+isContinue+'</IsContinue><isFirstUser>'+isConsentFirstUser+'</isFirstUser><idNum>'+idNum+'</idNum><broswerDetails><name>'+browserParams.broswerDetails.name+'</name><version>'+browserParams.broswerDetails.version+'</version><fullVersion>'+browserParams.broswerDetails.fullVersion+'</fullVersion><os>'+browserParams.broswerDetails.os+'</os></broswerDetails><hostName>'+browserParams.hostName+'</hostName><userAgent>'+browserParams.userAgent+'</userAgent></Fields>'
            params = {
                packageId: '12000',  
                dataFields: dfields
            }
        }
        else { //Subsequence users, first time + save&continue
            codeValue = idNum;
            storage.setIsFirstTime(false); //subsequent users + save & continue is false
            let dfields ='<Fields><stateId>'+stateId+'</stateId><type>'+type+'</type><referenceNo>'+storage.getRefNo()+'</referenceNo><IsContinue>'+isContinue+'</IsContinue><isFirstUser>'+isConsentFirstUser+'</isFirstUser><idNum>'+idNum+'</idNum><broswerDetails><name>'+browserParams.broswerDetails.name+'</name><version>'+browserParams.broswerDetails.version+'</version><fullVersion>'+browserParams.broswerDetails.fullVersion+'</fullVersion><os>'+browserParams.broswerDetails.os+'</os></broswerDetails><hostName>'+browserParams.hostName+'</hostName><userAgent>'+browserParams.userAgent+'</userAgent></Fields>'
            params = {
                packageId: '13000',  
                dataFields: dfields
            }
        }

        callPostState(params);
    }
   
    const getBrowserInfo = () => {
        let browserInfo = require('browser-info');
        const webDet = browserInfo();
        var browserDetails = navigator.userAgent;
        let params = {
            broswerDetails: webDet,
            hostName: window.location.hostname,
            userAgent: browserDetails,
        };

        return params;
    }
    const checkStatus = (resData) => {

        if(isFirstTimeUser) {
            if(resData.referenceNo === null) {  
                setIsLoading(false);
                showErrMsg('Something went wrong. Please try again.');
                return;
            }
        }
        
        storage.setStateId(resData.stateId);  //store the state id

        if(config.SERVER_STATUS === 'UAT' || config.SERVER_STATUS === 'PROD') {
            let clientID = resData.clientID;
            let scope = resData.scope;
            let returnURL = resData.returnURL;
            let packageName = resData.packageName;
            let appId = resData.appId;
            let clientSecret = resData.clientSecret;
            let packageId = resData.packageId;
            let stateId = resData.stateId;

            let singPassUrL = '';
 
            if(isFirstTimeUser) {
                singPassUrL= config.MyInfoGovt.BizURL;
            }
            else if(isConsentFirstUser=== true && isContinue === true){
                if(config.SERVER_STATUS === 'UAT') {
                    singPassUrL= config.MyInfoGovt.UATBizURL;
                }
                else {
                    singPassUrL= config.MyInfoGovt.BizURL;
                }
            }
            else {
                if(config.SERVER_STATUS === 'UAT') {
                    singPassUrL = config.MyInfoGovt.UATPersonURL;
                } 
                else {
                    singPassUrL = config.MyInfoGovt.PersonURL;
                }
            }

            let paramPass = "?authmode=SINGPASS" +
                "&purpose=" + packageName +
                "&response_type=code" +
                "&attributes=" + scope +
                "&state=" + stateId +
                "&redirect_uri=" + returnURL +
                "&client_id=" + clientID;

            window.location.href = singPassUrL + paramPass; 
        }
        else { //SIM, DEV, SIT
            history.push('MyInfoLanding?state='+resData.stateId,{from: config.route.Welcomecode});
        }
    }

    const handleChkChange = (e) => {
      
        setIsChecked(e.value);
    }

    const getOptionfromQueryString= () => {  
     
        try {
            if(props.location.state !== undefined) { //not first time
                setStateId(props.location.state.sid);
                setUserName(props.location.state.n);
                setIsContinue(props.location.state.isCont === "true"? true:false);
                setIsConsentFirstUser(props.location.state.isFU === "true"? true:false);
                setIDNum(props.location.state.ic);
                setType(props.location.state.type)
                setUEN(props.location.state.uen);
                setFirstTimeUser(false);
                if(storage.getIsFProdBTL() === 't') { //BTL
         
                    faCb1Data = welcomedata.greenCb1.data;
                    faCb2Data = welcomedata.greenCb2.data;
                    faCb3Data = welcomedata.greenCb3.data;
                }
                else {
                  
                    faCb1Data = welcomedata.greenCb1.hybridData;
                    faCb2Data = welcomedata.greenCb2.hybridData;
                    faCb3Data = welcomedata.greenCb3.hybridData;
                }
            }
            else {  //first time
                setFirstTimeUser(false);
                setIsContinue(false);
            }
            setIsLoading(false);
        }catch(ex) {
            setIsLoading(false);
        }
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }
    
    return(
        <div className="container-fluid">            
            <SubHeader title={config.Branding.title}  />
            <div className="container-fluid">
                <p className="bgtxt k-align-items-center">{titleName}</p> 
                <div className="demo-section k-content dynmicwhitecntr DynamicFields">
                    <div className="cardbd">
                        <CardImage className="hdImg" alt="bImag1" src={bannerImg}  /> 
                        <br/><br/>

                        {!isFirstTimeUser &&
                        <div className="fbaList" style={{ textAlign: "left", paddingTop:'10px' }}>
                            <div className="row">
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                    <p className="cdbdtxtTitle fbaPSize fbaPWeight"> Welcome {userName}!</p> 
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                    <p className="cdbdtxtTitle fbaPSize fbaPWeight">Review and complete your applicant form.</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                    <p className="cdbdtxtTitleYellow fbaPSize">Application Number: <b>{storage.getRefNo()}</b></p>  
                                </div>
                            </div>
                        </div> }
                   
                        <div className="fbaList" style={{ textAlign: "left" }}><br/>                        
                            <div className="row">
                                <div className="col-8 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.greenCb1.header}</p>
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>                     
                            
                            <div className="row text-secondary">                          
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">                                          
                                    {faCb1Data.map((item, idx) => (
                                        <CusFaCb key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>      
                            </div><br/><br/>

                            <div className="row">
                                <div className="col-8 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.greenCb2.header}</p> 
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>
                        
                            <div className="row text-secondary"> 
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11  text-secondary">                                       
                                    {faCb2Data.map((item, idx) => (
                                        <CusFaCb key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>   
                                      
                            </div><br/><br/>

                            <div className="row">
                                <div className="col-9 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.greenCb3.header}</p> 
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>

                            <div className="row text-secondary"> 
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">                                       
                                    {faCb3Data.map((item, idx) => (
                                        <CusFaCb key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>
                            </div><br/>
                            {(storage.getIsFProdBTL() === 'f') &&
                            <div className="row text-secondary"> 
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">  
                                    <div className='smallFontSize'>
                                    *Applicable only if not previously provided.
                                    </div>
                                </div>
                            </div>
                            }
                            <br/> 
             
                                                
                        </div><br/><br/>   
                        <div style={{textAlign:'center'}}>
                       
                        <img className='btMyInfoWdt' src={myInfoBtn} onClick={() => setButtonPopup(true)} />
                        </div> 
                        <br/>

                        <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                            <div style={{ textAlign: "left", width:'100%' }}>
                                <div className="bgBlack fbaPSize">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                        <div className="dcPgmh">{fbaData.dcPopup.header}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="bgGrey fbaPSize" style={{paddingTop:'5px',paddingBottom:'5px'}}>         
                                <div className="row">     
                                    <div className="dcPgm col-8"><b>Declaration</b></div>
                                    <div className="col-3" style={{ textAlign: "right" }} onClick={()=>setShow(!show)} >
                                        {
                                        show?<div>Hide <FcCollapse /></div>:<div className="">Show <FcExpand /></div>
                                        } 
                                    </div>
                                </div> 
                            {show?
                            <div className="row">     
                                <div className="col-10 dcPgm">                                     
                                    {dcData.map((item, idx) => (
                                        <CusParagraph key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>
                            </div>:null
                            } 
                        </div>
                    </div> 
                    <p style={{ marginTop: "1rem", fontWeight: "700",textAlign: "center"  }}> {'Retrieve Myinfo with'} <img src={singPassImg} width="90px" /></p>
            
                    <div className="fbaPSize" style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap',paddingBottom:'10px' }}>                        
                        <Checkbox defaultChecked={isChecked} label={fbaData.dcPopup.cbdata} onChange={handleChkChange} />                                
                    </div>
                    {fbaData.dcPopup.declareList.map((item, idx) => (
                        <div key={idx}>
                        <div style={{textAlign: "left", display: 'flex', flexWrap: 'wrap',color:'#585858' }}>
                                <ol style={{listStyle: "disc", marginBottom: "0", fontSize: "x-small"}}> 
                                    <li>{item.lblname}</li>
                                </ol>
                            </div>
                        </div>
                    ))}
                    <br/>
                
                    <div className="row">
                        <div className="col-6" style={{ textAlign: "left"}}>                        
                            <Button look="outline" className="btSize1" onClick={() => setButtonPopup(false)}>Back</Button>
                        </div> 
                        <div className="col-6" style={{ textAlign: "right"}}> 
                            <Button primary={true} className="btSize1 sccbTxt2 btRht greenbt" onClick={handleProceed} disabled={!isChecked}>Proceed</Button>
                        </div>
                    </div> 
                </Popup>   
            </div> 
            <br/>
            <br/><br/> 
            </div>
            </div>
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
        </div>
    );
}

export default Welcome;